import {Component} from '@angular/core';

@Component({
    selector: 'app-i-arrow',
    template: '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '    <path d="M1 13.1328L7 7.13281L1 1.13281" stroke="#10082F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '</svg>'
})
export class IArrowComponent {
}
